import { OrientationType } from "./core/ScaleManager";
import F84Game from "./Game";
import InitialLoadUtils from "./utils/InitialLoadUtils";

window.addEventListener("DOMContentLoaded", (): void => {
	InitialLoadUtils.injectInitialLoader();
});

window.onload = (): void => {
	//Configure WebGL canvas for Phaser
	const canvas = document.createElement("canvas");
	document.body.appendChild(canvas);
	const canvasContext = <CanvasRenderingContext2D>(<unknown>canvas.getContext("webgl", {
		alpha: false,
		depth: true,
		antialias: true,
		premultipliedAlpha: true,
		stencil: true,
		preserveDrawingBuffer: false,
		failIfMajorPerformanceCaveat: false,
		powerPreference: "default",
	}));

	//Determine base resolution based on mission orientation
	const size = { w: 1920, h: 1080 };

	//Launch Phaser
	(<any>window).game = new F84Game(canvas, canvasContext, size.w, size.h, OrientationType.LANDSCAPE);
};
